import { Box, Skeleton, Stack } from '@mui/material'

export const CustomTreeSkeleton = () => {
  return (
    <Stack sx={{ padding: '0 8px' }}>
      <Skeleton variant="text" animation="wave" width={90} height={30} />
      {Array.from(new Array(12)).map((_, index) => (
        <Box key={index} display="flex" alignItems="center" width="100%" sx={{ marginTop: '8px', marginLeft: '4px' }}>
          <Skeleton variant="text" animation="wave" width={20} height={30} style={{ marginRight: '8px' }} />
          <Skeleton variant="text" animation="wave" width="80%" height={30} />
        </Box>
      ))}
    </Stack>
  )
}